import { useContext, useState } from "react";
import UiContext from "../../../store/ui-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";

export const useAPIDeletePengisianMinyak = (props) => {
  const { onConfirmed } = props;
  const uiContext = useContext(UiContext);
  const { requestDelete, loading } = useAPIRequest();
  const [data, setData] = useState({});

  //  API call section

  const deleteData = async ({ id }) => {
    return requestDelete({
      fullUrl: "/api/transaksi/kendaraanpengisianminyak/delete",
      ids: [id],
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
      onSuccess: ({ message, data: _data }) => {
        uiContext.showSuccessMsg("Success", message);
        onConfirmed(data);
      },
    });
  };

  // other function section

  // handle ui event section

  const handleOnDelete = () => {
    deleteData(data);
  };

  return {
    data,
    setData,
    handleOnDelete,
  };
};
